module.exports = __webpack_public_path__ + "static/media/third_prize.13530fae.png";